// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { SiteModelBaseElement } from './SiteModelBaseElement';
import { Column } from './Column';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 网站 实体类
 * 网站
 */
export class Website extends SiteModelBaseElement {
  /** 编码 : 网站编码，全局唯一，推荐使用网站域名 */
  private _code: string;

  /** 设置：编码 */
  public get code() {
    return this._code;
  }

  /** 获取：编码 */
  public set code(value: string) {
    this._code = value;
  }

  /** 域名 : 网站访问的域名，如果是子站点，可采用二级域名 */
  private _domain: string;

  /** 设置：域名 */
  public get domain() {
    return this._domain;
  }

  /** 获取：域名 */
  public set domain(value: string) {
    this._domain = value;
  }

  /** 标题后缀 : 整站网页的标题后缀，附加到每一个页面的后面，空则不需要后缀，对网站首页不适用 */
  private _postfix: string;

  /** 设置：标题后缀 */
  public get postfix() {
    return this._postfix;
  }

  /** 获取：标题后缀 */
  public set postfix(value: string) {
    this._postfix = value;
  }

  /** 标题 : 网站首页的标题，用于Meta的Title */
  private _metaTitle: string;

  /** 设置：标题 */
  public get metaTitle() {
    return this._metaTitle;
  }

  /** 获取：标题 */
  public set metaTitle(value: string) {
    this._metaTitle = value;
  }

  /** 关键词 : 网站首页关键词，建议不超过4个词，中间用半角逗号分隔，用于Meta的Keywords */
  private _metaKeywords: string;

  /** 设置：关键词 */
  public get metaKeywords() {
    return this._metaKeywords;
  }

  /** 获取：关键词 */
  public set metaKeywords(value: string) {
    this._metaKeywords = value;
  }

  /** 元描述 : 网页描述，对应meta的description */
  private _metaDescription: string;

  /** 设置：元描述 */
  public get metaDescription() {
    return this._metaDescription;
  }

  /** 获取：元描述 */
  public set metaDescription(value: string) {
    this._metaDescription = value;
  }

  /** 栏目 */
  private _columns: Array<Column>;

  /** 获取：栏目 */
  public get columns() {
    return this._columns;
  }

  /** 设置：栏目 */
  public set columns(value: Array<Column>) {
    this._columns = value;
  }

  constructor() {
    super();
    this._code = '';
    this._domain = '';
    this._postfix = '';
    this._metaTitle = '';
    this._metaKeywords = '';
    this._metaDescription = '';
    this._columns = new Array<Column>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: Website, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.code = element.code;
      this.domain = element.domain;
      this.postfix = element.postfix;
      this.metaTitle = element.metaTitle;
      this.metaKeywords = element.metaKeywords;
      this.metaDescription = element.metaDescription;
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.code = json.Code;
    this.domain = json.Domain;
    this.postfix = json.Postfix;
    this.metaTitle = json.MetaTitle;
    this.metaKeywords = json.MetaKeywords;
    this.metaDescription = json.MetaDescription;
    if (json.Columns && json.Columns.length > 0) {
      json.Columns.forEach((element: any) => {
        const column = Column.Create(element);
        // column.website = this;
        this.columns.push(column);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Code = this.code;
    json.Domain = this.domain;
    json.Postfix = this.postfix;
    json.MetaTitle = this.metaTitle;
    json.MetaKeywords = this.metaKeywords;
    json.MetaDescription = this.metaDescription;
    if (this.columns && this.columns.length > 0) {
      json.Columns = [];
      this.columns.forEach((element) => {
        json.Columns.push(element.toJson());
      });
    }
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('基本属性', 'code', '编码', EnumDataType.String, this.code, true, '网站编码，全局唯一，推荐使用网站域名', '', '');
    context.addRow('基本属性', 'domain', '域名', EnumDataType.String, this.domain, true, '网站访问的域名，如果是子站点，可采用二级域名', '', '');
    context.addRow('基本属性', 'postfix', '标题后缀', EnumDataType.String, this.postfix, true, '整站网页的标题后缀，附加到每一个页面的后面，空则不需要后缀，对网站首页不适用', '', '');
    context.addRow('SEO属性', 'metaTitle', '标题', EnumDataType.String, this.metaTitle, true, '网站首页的标题，用于Meta的Title', '', '');
    context.addRow('SEO属性', 'metaKeywords', '关键词', EnumDataType.String, this.metaKeywords, true, '网站首页关键词，建议不超过4个词，中间用半角逗号分隔，用于Meta的Keywords', '', '');
    context.addRow('SEO属性', 'metaDescription', '元描述', EnumDataType.String, this.metaDescription, true, '网页描述，对应meta的description', '', '');
    return context;
  }

  static Create(json: any): Website {
    const website = new Website();
    website.Deserialize(json);
    website.json = json;
    return website;
  }
}
